import React from 'react'
import { message, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { updateUser } from '../../../services/user'

const { confirm } = Modal

const updateEmployeeWithBlock = (userId, onSuccess) => {
  const data = { blocked: true }

  updateUser(userId, data)
    .then(onSuccess)
    .catch((error) => {
      message.error(`Ошибка при обновлении пользователя ${error}`)
      console.warn(error)
    })
}

export const blockEmployee = (record, onSuccess) => {
  const { id, username } = record
  confirm({
    title: 'Заблокировать пользователя',
    icon: <ExclamationCircleOutlined />,
    content: `Пользователь ${username}`,
    okText: 'Да',
    okType: 'danger',
    cancelText: 'Нет',
    onOk() {
      updateEmployeeWithBlock(id, onSuccess)
    },
    onCancel() {
      // nothing
    },
  })
}
